$(document).ready(function () {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function () {
      if ($('#agree_agb').is(':checked') && $('#agree_widerruf').is(':checked')) {
          $(this).submit();
      }
      else {
          alert("Bitte akzeptieren Sie unsere Bedingungen, bevor Sie Ihren Kauf fortsetzen.");
          return false;
      }
  });
  $('body').on('click', '[name="contact-submit"]', function () {
      if ($('#agree_contact').is(':checked')) {
          $(this).submit();
      }
      else {
          alert("Bitte akzeptieren Sie unsere Datenschutzhinweise, bevor Sie Ihre Nachricht absenden.");
          return false;
      }
  });
});
